import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useParams } from 'react-router-dom';

const BlogPost = () => {
    const { slug } = useParams();
    const [content, setContent] = useState('');

    useEffect(() => {
        import(`../posts/${slug}.md`)
            .then((file) => fetch(file.default).then((res) => res.text()))
            .then((text) => setContent(text))
            .catch(() => setContent('# Post Not Found'));
    }, [slug]);

    return (
        <div className="blog-post">
            <ReactMarkdown>{content}</ReactMarkdown>
        </div>
    );
};

export default BlogPost;
